import * as React from 'react';

interface WorldIconProps extends React.SVGProps<SVGSVGElement> {}

export const WorldIcon = React.memo(({
  width = 16,
  height = 16,
  viewBox = '0 0 16 16',
  ...props
}: WorldIconProps) => (
  <svg
    width={width}
    height={height}
    viewBox={viewBox}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path transform="translate(2, 2)" d="M12 6C12 9.32812 9.30469 12 6 12C2.67188 12 0 9.32812 0 6C0 2.69531 2.67188 0 6 0C9.30469 0 12 2.69531 12 6ZM1.33594 4.52344L1.57031 4.92188C1.75781 5.25 2.0625 5.50781 2.46094 5.625L3.79688 6C4.21875 6.11719 4.5 6.49219 4.5 6.91406V7.85156C4.5 8.10938 4.64062 8.34375 4.875 8.4375C5.08594 8.55469 5.25 8.78906 5.25 9.04688V9.96094C5.25 10.3359 5.57812 10.5938 5.92969 10.5C6.32812 10.3828 6.60938 10.0781 6.70312 9.70312L6.77344 9.44531C6.86719 9.04688 7.125 8.71875 7.47656 8.50781L7.66406 8.39062C8.01562 8.20312 8.25 7.82812 8.25 7.42969V7.21875C8.25 6.9375 8.10938 6.63281 7.89844 6.42188L7.82812 6.35156C7.61719 6.14062 7.3125 6 7.03125 6H6C5.74219 6 5.48438 5.95312 5.27344 5.8125L4.45312 5.34375C4.35938 5.29688 4.28906 5.20312 4.24219 5.08594C4.17188 4.875 4.26562 4.61719 4.47656 4.52344L4.61719 4.45312C4.78125 4.35938 4.94531 4.35938 5.10938 4.40625L5.67188 4.59375C5.85938 4.66406 6.07031 4.57031 6.1875 4.40625C6.28125 4.24219 6.28125 4.03125 6.14062 3.86719L5.83594 3.49219C5.60156 3.21094 5.60156 2.8125 5.83594 2.53125L6.21094 2.10938C6.42188 1.85156 6.44531 1.52344 6.28125 1.24219L6.23438 1.14844C6.14062 1.14844 6.07031 1.125 6 1.125C3.82031 1.125 1.96875 2.55469 1.33594 4.52344ZM10.2422 3.63281L9.65625 3.86719C9.28125 4.03125 9.09375 4.42969 9.21094 4.80469L9.60938 6C9.67969 6.23438 9.89062 6.42188 10.1484 6.49219L10.8281 6.65625C10.8516 6.44531 10.875 6.23438 10.875 6C10.875 5.15625 10.6406 4.33594 10.2422 3.63281Z" fill="currentColor" />
  </svg>
));

WorldIcon.displayName = 'WorldIcon';

export default WorldIcon;
